<div class="login-attendee-drawer" >
    <div class="row row--builder" [ngClass]="{'login-border' : isPopUp==false}" *ngIf="(loginConfig.body.isSSOEnabled && loginConfig.body.ssoConfigs.length>0) || (this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
        <div class="col col--builder">
            <div>
                <h3 [ngClass]="['header', 'login-header-background']">
                    <span [ngClass]="'login-header-label'">
                        Forgot Password
                    </span>
                    <span *ngIf="isPopUp" class="pull-right login-header-label" title="Close" (cclClick)="close()">
                        X
                    </span>
                </h3>
            </div>

            <div class="login-drawer-body">
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div *ngIf="(this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
                        <div class="login-body-help">
                            <span> Enter your username or email and we will send the instructions</span>
                        </div>
                        <div class="login-body">
                            <div class="c-form-group">
                                <input
                                    aria-label="forgotPassword"
                                    cclFormInput
                                    id="forgotPassword-label"
                                    type="text"
                                    role="textbox"
                                    class="c-c-form-group__input form-control"
                                    placeholder="Username or Email"
                                    [(ngModel)]="forgotPasswordModal.email"
                                />
                                <div class="c-form-group__hint">&nbsp;</div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="login-drawer-footer" *ngIf="(this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin'))">
                <div class="row row--builder">
                    <div class="col--builder col col-sm-7 col-xs-7">
                        <div class="login-footer-help">
                            <span> <a href="javascript:void(0)" (click)="openPopup('login')"> Back to Login </a> </span>
                        </div>
                    </div>
                    <div class="col--builder col col-sm-5 col-xs-5">
                        <div class="login-footer-button">
                            <button
                                [ngClass]="['c-btn', 'c-btn--primary', 'login-footer-button-primary' ,'pull-right']"
                                (click)="sendEmail()"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>